<h1 mat-dialog-title>{{ isCreate ? 'Crear equipo de producto' : 'Editar equipo de producto' }}</h1>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>Nombre del equipo</mat-label>
          <input matInput type="text" formControlName="name" />
          @if (form.controls['name'].hasError('required')) {
            <mat-error>El nombre es obligatorio</mat-error>
          } @else if (form.controls['name'].hasError('minlength')) {
            <mat-error>El nombre debe tener al menos 5 caracteres</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>Usuarios en el equipo</mat-label>
          <mat-chip-grid #chipGridUsers>
            @for (user of form.value.users; track user; let i = $index) {
              <mat-chip-row (removed)="removeUser(i)">
                {{ user.name + ' ' + user.surnames }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
            <input
              placeholder="Buscar usuarios..."
              #users_input
              [formControl]="usersSearchCtrl"
              [matChipInputFor]="chipGridUsers"
              [matAutocomplete]="autoUsers"
            />
            <mat-autocomplete #autoUsers="matAutocomplete" (optionSelected)="selectedUser($event)">
              @for (user of filteredUsers | async; track user.id) {
                <mat-option [value]="user">
                  {{ user.name + ' ' + user.surnames }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-chip-grid>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>Fases asignadas</mat-label>
          <mat-select formControlName="company_product_phase_ids" multiple>
            @for (phase of company_product_phases; track phase.id) {
              <mat-option [value]="phase.id">{{ phase.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <p class="phases-hint">
          Solo se listan las fases activas del producto. Puede haber más de una del mismo tipo (por ejemplo varios Product Delivery o KTLO).
        </p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" [disabled]="!form.valid" (click)="submit()">
    {{ isCreate ? 'Crear equipo' : 'Actualizar equipo' }}
  </button>
</mat-dialog-actions>
